__turbopack_context__.v({
  "btnWrp": "styles-module__o2h5ia__btnWrp",
  "footer": "styles-module__o2h5ia__footer",
  "footerContent": "styles-module__o2h5ia__footerContent",
  "footerLink": "styles-module__o2h5ia__footerLink",
  "footerLinks": "styles-module__o2h5ia__footerLinks",
  "footerLogo": "styles-module__o2h5ia__footerLogo",
  "footerWrap": "styles-module__o2h5ia__footerWrap",
});
